import { getDefaultDisplayMode } from "../../../components-ui/resizable-sidebar";
import { IMucThuActionTypes } from "../../action-types/muc-thu/IMucThuActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IMucThuReducer } from "../../reducer-model/muc-thu/IMucThuReducer";
const iniState: IMucThuReducer = {
  status: eReducerStatusBase.is_not_initialization,
  sinhViens: [],
  displayMode: getDefaultDisplayMode(),
  loaiThuChiId: 0,
  mucThuKhacs: [],
  sinhVienSelectedIds: [],
  doiTuongIds: [],
  filerMode: "all",
  kyDangKyId: 0,
  dotNhapHoc: 0,
  trangThaiHocs: [0],
  isShowImportModal: false,
  isShowImportResultModal: false,
  statusSaveImport: eReducerStatusBase.is_not_initialization,
  cacheIdImport: "",
  dot: 0,
};
export const mucThuReducer = (
  state: IMucThuReducer = iniState,
  action: IMucThuActionTypes,
): IMucThuReducer => {
  switch (action.type) {
    case "MUC_THU_CHANGE_DISPLAY_MODE":
      return {
        ...state,
        displayMode: action.payload,
      };
    case "MUC_THU_CHANGE_FOCUS_TREEVIEW_VALUE":
      return {
        ...state,
        focusedValue: action.payload,
        focusedCell: undefined,
        sinhVienSelectedIds: [],
      };
    case "MUC_THU_LOAD_HOCSINH_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        sinhVienSelectedIds: [],
      };
    case "MUC_THU_LOAD_HOCSINH_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        sinhViens: action.payload,
      };
    case "MUC_THU_LOAD_HOCSINH_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_THU_CHANGE_LOAI_THU_CHI":
      return {
        ...state,
        loaiThuChiId: action.payload,
      };
    case "MUC_THU_CHANGE_SINHVIEN_SELECTED_IDS":
      return {
        ...state,
        sinhVienSelectedIds: action.payload,
      };
    case "MUC_THU_SHOW_INPUT_MODAL":
      return {
        ...state,
        isShowInputModal: action.payload,
      };
    case "MUC_THU_LOAD_MUCTHUKHAC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "MUC_THU_LOAD_MUCTHUKHAC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucThuKhacs: action.payload,
        focusedCell: undefined,
      };
    case "MUC_THU_LOAD_MUCTHUKHAC_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucThuKhacs: [],
        focusedCell: undefined,
      };
    case "MUC_THU_CREATE_MUCTHUKHAC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_THU_CREATE_AND_DUYET_MUCTHUKHAC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_THU_GAN_THEM_AND_DUYET_MUCTHUKHAC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_THU_SHOW_GAN_THEM_MODAL":
      return {
        ...state,
        isShowGanThemModal: action.payload,
      };
    case "MUC_THU_CREATE_MUCTHUKHAC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucThuKhacs: action.payload,
        isShowInputModal: false,
        focusedCell: undefined,
        sinhVienSelectedIds: [],
      };
    case "MUC_THU_CREATE_MUCTHUKHAC_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        isShowInputModal: false,
      };
    case "MUC_THU_DUYET_MUCTHUKHAC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        isShowProcessing: true,
        processId: action.payload.process_id,
      };
    case "MUC_THU_DUYET_MUCTHUKHAC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        sinhVienSelectedIds: [],
      };
    case "MUC_THU_DUYET_MUCTHUKHAC_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_THU_HUYDUYET_MUCTHUKHAC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        isShowProcessing: true,
        processId: action.payload.process_id,
      };
    case "MUC_THU_HUYDUYET_MUCTHUKHAC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        sinhVienSelectedIds: [],
      };
    case "MUC_THU_HUYDUYET_MUCTHUKHAC_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_THU_CLOSE_PROCESSING_MODAL":
      return {
        ...state,
        isShowProcessing: false,
      };
    case "MUC_THU_DELETE_MUCTHUKHAC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "MUC_THU_DELETE_MUCTHUKHAC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "MUC_THU_DELETE_MUCTHUKHAC_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    // Hủy và gỡ khoản thu: saga chain HuyDuyet → Deletes; outcome tái dùng HUYDUYET_SUCCESS / DELETE_ERRR.
    case "MUC_THU_HUY_VA_GO_MUCTHUKHAC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        isShowProcessing: true,
        processId: action.payload.process_id,
      };
    case "MUC_THU_CHANGE_FOCUSED_CELL":
      return {
        ...state,
        focusedCell: action.payload,
      };
    case "MUC_THU_UPDATE_MUCTHUKHAC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_THU_UPDATE_MUCTHUKHAC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        // focusedCell: undefined,
        mucThuKhacs: [
          ...state.mucThuKhacs.filter((x) => x.id !== action.payload.id),
          action.payload,
        ],
      };
    case "MUC_THU_UPDATE_MUCTHUKHAC_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_THU_CHANGE_MUC_THU_FILTER":
      return {
        ...state,
        filerMode: action.payload,
      };
    case "MUC_THU_CHANGE_KY_DANG_KY_ID": {
      return {
        ...state,
        kyDangKyId: action.payload,
      };
    }
    case "MUC_THU_CHANGE_STATUS": {
      return {
        ...state,
        status: action.payload,
      };
    }
    case "MUC_THU_CHANGE_TRANG_THAI_HOC": {
      return {
        ...state,
        trangThaiHocs: action.payload,
      };
    }
    case "MUC_THU_SHOW_HIDE_IMPORT_MODAL":
      return {
        ...state,
        isShowImportModal: action.payload,
      };
    case "MUC_THU_IMPORT_START": {
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    }
    case "MUC_THU_IMPORT_SUCESS": {
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucThuImports: action.payload.data,
        cacheIdImport: action.payload.cache_id,
        isShowImportModal: false,
        isShowImportResultModal: true,
      };
    }
    case "MUC_THU_IMPORT_ERROR": {
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    }

    case "MUC_THU_CHANGE_MUCTHU_IMPORT_SELECTEDS": {
      return {
        ...state,
        mucThuImportSelected: action.payload,
      };
    }
    case "MUC_THU_HIDE_IMPORT_RESULT_MODAL": {
      return {
        ...state,
        isShowImportResultModal: false,
      };
    }
    case "MUC_THU_SAVE_IMPORT_START": {
      return {
        ...state,
        statusSaveImport: eReducerStatusBase.is_saving,
        processId: action.payload.process_id,
        isShowProcessing: true,
      };
    }
    case "MUC_THU_SAVE_IMPORT_SUCESS": {
      return {
        ...state,
        statusSaveImport: eReducerStatusBase.is_saved,
        status: eReducerStatusBase.is_need_reload,
        isShowImportResultModal: false,
        mucThuImports: undefined,
        cacheIdImport: "",
        mucThuImportSelected: [],
      };
    }
    case "MUC_THU_SAVE_IMPORT_ERROR": {
      return {
        ...state,
        statusSaveImport: eReducerStatusBase.is_completed,
        isShowProcessing: false,
      };
    }
    case "MUC_THU_IMPORT_HUYDUYET_START": {
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    }
    case "MUC_THU_IMPORT_HUYDUYET_SUCESS": {
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucThuImports: action.payload.data,
        cacheIdImport: action.payload.cache_id,
        isShowImportModal: false,
        isShowImportResultModal: true,
      };
    }
    case "MUC_THU_IMPORT_HUYDUYET_ERROR": {
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    }
    case "MUC_THU_SAVE_IMPORT_HUYDUYET_START": {
      return {
        ...state,
        statusSaveImport: eReducerStatusBase.is_saving,
        processId: action.payload.process_id,
        isShowProcessing: true,
      };
    }
    case "MUC_THU_SAVE_IMPORT_HUYDUYET_SUCESS": {
      return {
        ...state,
        statusSaveImport: eReducerStatusBase.is_saved,
        status: eReducerStatusBase.is_need_reload,
        isShowImportResultModal: false,
        mucThuImports: undefined,
        cacheIdImport: "",
        mucThuImportSelected: [],
      };
    }
    case "MUC_THU_SAVE_IMPORT_HUYDUYET_ERROR": {
      return {
        ...state,
        statusSaveImport: eReducerStatusBase.is_completed,
        isShowProcessing: false,
      };
    }
    case "MUC_THU_CHANGE_DOT_NHAP_HOC": {
      return {
        ...state,
        dotNhapHoc: action.payload,
      };
    }
    case "MUC_THU_CHANGE_DOT_MUC_THU_KHAC": {
      return {
        ...state,
        dot: action.payload,
      };
    }
    case "MUC_THU_CHANGE_DOI_TUONG": {
      return {
        ...state,
        doiTuongIds: action.payload,
      };
    }
    default:
      return state;
  }
};
